var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AElf from 'aelf-sdk';
export const getAelfInstance = (rpcUrl, timeout = 20000) => {
    return new AElf(new AElf.providers.HttpProvider(rpcUrl, timeout));
};
/**
 * encodedTx
 * @returns raw string / { error: { message } }
 */
export const encodedTx = ({ instance, functionName, paramsOption, contract }) => __awaiter(void 0, void 0, void 0, function* () {
    const chainStatus = yield instance.chain.getChainStatus();
    const raw = yield contract[functionName].getSignedTx(paramsOption, {
        height: chainStatus === null || chainStatus === void 0 ? void 0 : chainStatus.BestChainHeight,
        hash: chainStatus === null || chainStatus === void 0 ? void 0 : chainStatus.BestChainHash,
    });
    return raw;
});
export const getELFContract = (rpcUrl, tokenAddress, privateKey) => __awaiter(void 0, void 0, void 0, function* () {
    const aelf = getAelfInstance(rpcUrl);
    const wallet = getWallet(privateKey);
    return yield aelf.chain.contractAt(tokenAddress, wallet);
});
export function getWallet(privateKey) {
    return AElf.wallet.getWalletByPrivateKey(privateKey);
}
export const getRawTx = ({ blockHeightInput, blockHashInput, packedInput, address, contractAddress, functionName, }) => {
    const rawTx = AElf.pbUtils.getTransaction(address, contractAddress, functionName, packedInput);
    rawTx.refBlockNumber = blockHeightInput;
    const blockHash = blockHashInput.match(/^0x/) ? blockHashInput.substring(2) : blockHashInput;
    rawTx.refBlockPrefix = Buffer.from(blockHash, 'hex').subarray(0, 4);
    return rawTx;
};
export function encodeTransaction(tx) {
    let _tx = AElf.pbUtils.Transaction.encode(tx).finish();
    if (_tx instanceof Buffer) {
        return _tx.toString('hex');
    }
    return AElf.utils.uint8ArrayToHex(_tx); // hex str
}
